import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0425e465"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }

import SvgIcon from "../svgicons/SvgIcon.vue";
import { MESSAGE_TIMEOUT } from "@/constants"
import { ref, onMounted } from "vue"
interface CMessageProps {
  text?: string,
  type?: string,
  timeout?: number,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CMessage',
  props: {
    text: {},
    type: { default: 'success' },
    timeout: { default: MESSAGE_TIMEOUT }
  },
  setup(__props: any) {

const props = __props


const isShow = ref<boolean>(false)
onMounted(() => {
  isShow.value = true
  setTimeout(() => {
    isShow.value = false
  }, props.timeout)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (isShow.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['c-message', _ctx.type])
          }, [
            _createVNode(SvgIcon, {
              class: "c-message-icon",
              icon: _ctx.type
            }, null, 8, ["icon"]),
            _createElementVNode("span", _hoisted_1, _toDisplayString(props.text), 1)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})